import { FIRM_NAME } from '../shared/firm';

export function NewIntakeDelivery({ smsEnabled }: { smsEnabled: boolean }) {
	if (!smsEnabled) return <input type="hidden" name="sendEmail" value="on" />;

	return (
		<fieldset>
			<legend>Delivery</legend>
			<label className="inline">
				<input type="checkbox" name="sendEmail" defaultChecked />
				Email
			</label>
			<label className="inline">
				<input type="checkbox" name="sendSms" />
				Text message
			</label>
			<label className="inline">
				<input type="checkbox" name="smsConsent" />I confirm the client expressly agreed to receive automated questionnaire links and
				appointment reminders from {FIRM_NAME} at this number. Message and data rates may apply. Consent is not a condition of legal
				services. The client was told to reply STOP to opt out or HELP for help.
			</label>
			<label>
				How consent was obtained
				<select name="smsConsentMethod" defaultValue="verbal">
					<option value="verbal">Verbally</option>
					<option value="written">In writing</option>
					<option value="web">Through a web form</option>
				</select>
			</label>
		</fieldset>
	);
}
